<template>
  <b-card no-body class="shadow layer-manager h-100 flex-container grid-stack-item-content">
    <div slot="header">
      <window-header cmp-title="Layer Control" widget-name="layers">
        <template slot="left-options">
          <span id="layer-control-wiki-link" @click="openWiki" v-b-tooltip.hover title='Layer Control Wiki Link'><icon name="question-circle"></icon></span>
        </template>
      </window-header>
    </div>

    <div class="flex-full-height">
      <b-container class="p-2">
        <div class="layer-control-tags" v-if="tags.length">
          <b-btn v-b-toggle.tag-collapse class='toggle-tags' variant="primary">
            <span class="when-opened">Hide Tags</span>
            <span class="when-closed">Show Tags</span>
          </b-btn>
          <b-collapse visible id="tag-collapse" class="mt-0">
            <b-form-checkbox-group buttons button-variant="outline-secondary" size='sm' id="layer-tags" v-model="selectedTags" :options="tags">
            </b-form-checkbox-group>
          </b-collapse>
        </div>
        <b-input-group id="filterLayerGroup" label-for="filterLayers">
          <b-form-input ref="filterInput" v-model="filterKey" class="input-xs" id="filterLayers" type="text" placeholder="Type to filter layers">
            <b-btn><icon name="filter" scale=".6" label="Filter layers"></icon></b-btn>
          </b-form-input>
          <b-input-group-append>
          <b-btn v-b-tooltip.hover variant="primary" @click="filterKey = ''" class="btn-xs filter-remove" title="Clear filter">
            <icon name="window-close" scale="0.6"></icon>
          </b-btn>
        </b-input-group-append>
        </b-input-group>
      </b-container>

      <div class="flex-full-height">

        <b-container class="layerManager-top" ref="listRoot">
          <template v-for="layer in layerTree">
            <layer-control-item v-if="!layer['hidden']" :layerItem="layer"
                                :key="layer.id || layer.group.id"></layer-control-item>
          </template>

        </b-container>
      </div>
    </div>

    <window-footer></window-footer>
  </b-card>
</template>
<script>
  import 'vue-awesome/icons/window-close'
  import 'vue-awesome/icons/filter'
  import LayerControlItem from './LayerControlItem.vue'
  import Sortable from 'sortablejs'
  import WindowHeader from '../../common/WindowHeader'
  import WindowFooter from '../../common/WindowFooter'

  export default {
    components: {WindowHeader, WindowFooter, LayerControlItem},
    name: 'layer-control',
    data () {
      return {
        filterKey: '',
        tags: [],
        selectedTags: []
      }
    },
    mounted () {
      Sortable.create(this.$refs.listRoot, {
        handle: '.sortable-handler',
        onEnd: (e) => {
          let data = {
            layerId: parseInt(e.item.dataset.id),
            isRoot: true,
            oldPos: e.oldIndex,
            newPos: e.newIndex,
          }

          this.$store.dispatch('map/layerPosition', data)
        }
      })

      this.$refs.filterInput.$el.style.zIndex = undefined
      this.extractTags(this.layerTree)
    },
    computed: {
      wikiProjectId: {
        get () {
          return this.$store.getters['project/wikiProjectId']
        },
        set (val) {
          this.$store.getters['project/wikiProjectId'] = val
        }
      },
      layerTree () {
        let tree = this.$store.getters['map/layersTree']
        if (!this.$mapService) {
          return tree
        }

        this.$mapService.walkTree(tree, l => {
          if (l.state === 'disabled') {
            l.hidden = true
          } else {
            l.hidden = false
          }
        })
        tree.forEach(l => {
          if (l.group) {
            l.hidden = false
          }
        })

        if (this.filterKey || this.selectedTags.length) {
          this.$mapService.walkTree(tree, l => {
            if (l.group) {
              return
            }
            if (l['name'].toLowerCase().indexOf(this.filterKey.toLowerCase()) === -1 && l['title'].toLowerCase().indexOf(this.filterKey.toLowerCase()) === -1) {
              l.hidden = true
            }
            if (this.selectedTags.length) {
              let visible = false
              this.selectedTags.forEach(t => {
                if (!l.hidden && l.tags && l.tags.indexOf(t) > -1) {
                  visible = true
                }
              })
              l.hidden = !visible
            }
            tree.forEach(l => {
              if (l.group) {
                if (!l.children.filter(l => !l.hidden).length) {
                  l.hidden = true
                } else {
                  l.group.expanded = true
                }
              }
            })
          })
        } else {
          this.$mapService.walkTree(tree, l => {
            tree.forEach(l => {
              if (l.group) {
                if (!l.children.filter(l => !l.hidden).length) {
                  l.hidden = true
                }
              }
            })
          })
        }
        tree.forEach(n => {
          if (n.children && n.name != 'Base') {
            n.children.sort((a, b) => (a.title > b.title) ? 1 : -1)
          }
        })
        return tree
      }
    },
    watch: {
      layerTree (val) {
        this.extractTags(val)
      }
      /*labels (val) {
        this.setLayerLabel(val)
        this.renderedLabelsMap[this.layer['id']] = val
      }*//*,
      layer (val) {

        if (val) {
          this.availableFields = val['fields'].map(f => {
            return {
              value: f.name,
              text: f.name
            }
          })
          this.labels = this.renderedLabelsMap[this.layer['id']] || []
          this.showLabelModal = true
        }
      }*/
    },
    methods: {
      extractTags (layerTree) {
        let c = {}
        this.$mapService.walkTree(layerTree, node => {
          node.tags && node.tags.split(',').forEach(t => {
            c[t.trim()] = true
          })
        })
        this.tags = []
        Object.keys(c).forEach(k => this.tags.push({text: k, value: k}))
        this.tags.sort(function(a, b){
            if(a.text < b.text) return -1;
            if(a.text > b.text) return 1;
            return 0;
        })
      },
      openWiki () {
        let win = window.open('/mine/projects/' + this.wikiProjectId + '/wiki/Layer_manager')
        win.focus()
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/map/layers/LayerControl.vue